import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKFormElement from '@tk/controls/tk.form.element';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKTable from '@tk/components/tk.table';
import TKFlag from '@tk/components/tk.flag';
import TKTooltip from '@tk/components/tk.tooltip';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKDialog from '@tk/components/tk.dialog';
import TKCompareContent from '@tk/components/tk.compare.content';
import TKCompareWrapper from '@tk/components/tk.compare.wrapper';
import TKCompareButton from '@tk/components/tk.compare.button';
import TKCompareSelect from '@tk/components/tk.compare.select';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/compare.scss';

export default class Compare extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-basket-button', constructor: TKBasketButton },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-compare-content', constructor: TKCompareContent },
            { name: 'tk-compare-wrapper', constructor: TKCompareWrapper },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-compare-select', constructor: TKCompareSelect },
        ]);
    }
}

// eslint-disable-next-line no-new
new Compare();
